/**
 * Session hydration helpers — token first, then GET /auth/me before dashboard render.
 */

import { entitlementsReady } from "../lib/entitlements";
import { authDebug, summarizeMeUser } from "../lib/authDebug";

export function normalizeMeUser(data) {
  if (!data || !data.id) {
    const err = new Error("Incomplete auth/me payload");
    err.code = "AUTH_HYDRATION_INCOMPLETE";
    throw err;
  }
  const entitlements =
    data.entitlements && typeof data.entitlements === "object" && !Array.isArray(data.entitlements)
      ? data.entitlements
      : {};
  return { ...data, entitlements };
}

export function isHydratedUser(user) {
  // Require real entitlement limits from /auth/me — empty {} must NOT count as ready
  // (otherwise UI defaults to Free limits and hides Business controls).
  return entitlementsReady(user);
}

export async function fetchCurrentUser(apiClient) {
  authDebug("auth/me requested");
  const res = await apiClient.get("/auth/me");
  const me = normalizeMeUser(res.data);
  authDebug("auth/me response received", summarizeMeUser(me));
  if (!isHydratedUser(me)) {
    authDebug("auth/me incomplete entitlements", summarizeMeUser(me));
    const err = new Error("Entitlements missing from auth/me");
    err.code = "AUTH_HYDRATION_INCOMPLETE";
    throw err;
  }
  authDebug("entitlements applied", summarizeMeUser(me));
  return me;
}

/**
 * After a token is stored in localStorage, load the canonical user (plan + entitlements).
 * On failure, clears the token via clearToken() so stale sessions cannot linger.
 */
export async function hydrateSession(apiClient, { clearToken }) {
  try {
    return await fetchCurrentUser(apiClient);
  } catch (err) {
    authDebug("hydrateSession failed", { code: err?.code || err?.response?.status || "error" });
    if (typeof clearToken === "function") clearToken();
    throw err;
  }
}
